const CDN_DOMAIN_MAP = {
  'img3.zthd.io': 'img3.yintuhc.cn',
  'img2.zthd.io': 'img2.yintuhc.cn',
  'img-push.zthd.io': 'img-push.yintuhc.cn',
  'img.zthd.io': 'img.yintuhc.cn',
}

const CDN_BASE = 'https://img.yintuhc.cn'

/**
 * 将旧 CDN 域名替换为国内 CDN 域名
 * 支持传入完整 URL 或路径片段
 * @param {string} url - 原始 URL
 * @returns {string} 替换后的 URL
 */
export const cdnUrl = (url) => {
  if (!url) return url
  for (const [oldDomain, newDomain] of Object.entries(CDN_DOMAIN_MAP)) {
    if (url.includes(oldDomain)) {
      return url.replaceAll(oldDomain, newDomain)
    }
  }
  return url
}

/** 刷新列表时绕过 CDN/浏览器对 404 的缓存 */
export const withCacheBust = (url, t) => {
  if (!url || !t) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}t=${t}`
}

/**
 * 生成组件缩略图 CDN 地址
 * @param {string} id - 组件 ID
 * @returns {string}
 */
export const cptThumb = (id) => `${CDN_BASE}/an1/ats/${id}`

/**
 * 生成图层图标 CDN 地址
 * @param {string} id - 图层图标 ID
 * @returns {string}
 */
export const layerIcon = (id) => `${CDN_BASE}/an1/acs/${id}`

/**
 * Spine 静态模版 SKU 原图 CDN（须与 server spine-static-skus/o 一致）
 * @param {string} originalAssetId
 * @returns {string}
 */
export const spineStaticOriginalUrl = (originalAssetId) =>
  originalAssetId ? `${CDN_BASE}/an1/spine-static-skus/o/${originalAssetId}.webp` : ''

/**
 * Spine 静态模版 SKU 缩略图 CDN（须与 server spine-static-skus/t 一致）
 * @param {string} thumbAssetId
 * @returns {string}
 */
export const spineStaticThumbUrl = (thumbAssetId) =>
  thumbAssetId ? `${CDN_BASE}/an1/spine-static-skus/t/${thumbAssetId}.webp` : ''
